import { useEffect } from 'react';

import { useDownloadSolusSDK } from './useDownloadSolusSDK';
import { useOnSolusError } from './useOnSolusError';
import { useOnSolusHint } from './useOnSolusHint';
import { useRequestSolusPacket } from './useRequestSolusPacket';

export const useSolusIntegration = ({
    sdk,
    enable,
    solusClientURL,
    license,
    identifierType,
    transactionID,
    userId,
    useTransparentPopup,
    onConnect,
    setShowOverlay,
    receivePacket,
    triggerGeolocation,
    reasonRef
}) => {
    const downloadSolusSDK = useDownloadSolusSDK({ solusClientURL });
    const requestSolusPacket = useRequestSolusPacket({
        sdk,
        license,
        transactionID,
        userId,
        identifierType,
        reasonRef
    });
    const onError = useOnSolusError({
        sdk,
        transactionID,
        setShowOverlay,
        useTransparentPopup
    });
    const onHint = useOnSolusHint({
        sdk,
        transactionID,
        setShowOverlay,
        useTransparentPopup,
        triggerGeolocation
    });

    /**
     * Ensures, that proper callbacks are connected to GeoComply SDK.
     */
    useEffect(() => {
        if (!enable || !sdk || !transactionID) {
            return;
        }

        const geolocation = (data) => receivePacket(data, 'geocomply_browser', transactionID);

        sdk.events.on('*.failed', onError);
        sdk.events.on('success', geolocation);
        sdk.events.on('hint', onHint);

        return () => {
            sdk.events.off('*.failed', onError);
            sdk.events.off('success', geolocation);
            sdk.events.off('hint', onHint);
        };
    }, [sdk, enable, onError, onHint, receivePacket, transactionID]);

    useEffect(() => {
        if (!enable || !sdk) {
            return;
        }

        onConnect();
    }, [sdk, enable, onConnect]);

    return {
        requestSolusPacket,
        downloadSolusSDK
    };
};
